<template>
  <div>
    <navigation></navigation>
    <div class="classic-shell">
      <div class="experience-switch">
        <span class="experience-pill">New</span>
        <span class="experience-text">We've redesigned the proof list.</span>
        <router-link to="/proof-list" class="experience-link">Try the new experience →</router-link>
      </div>
      <div class="container-fluid classic-body">
        <div class="row">
          <sidebarproof />
          <div class="col-md-9 ">
            <prooflist />
          </div>
        </div>
      </div>
    </div>
    <modalManageTags />
    <modalManageTagFilters />
    <renameItem />
    <v-tour
      name="proof-archive"
      :steps="steps"
      :callbacks="tourCallbacks"
    ></v-tour>
  </div>
</template>

<script>
import sidebarproof from "../components/proof-archive/sidebar-proof.vue";
import prooflist from "../components/proof-archive/proof-list.vue";
import modalManageTags from "../components/modals/modal-managetags.vue";
import modalManageTagFilters from "../components/modals/modal-managetagsfilters.vue";
import renameItem from "../components/modals/modal-renameItem";

export default {
  components: {
    sidebarproof,
    prooflist,
    modalManageTags,
    modalManageTagFilters,
    renameItem,
  },
  data() {
    return {
      user: this.$A.Auth,
      proofs: [],
      steps: [
        {
          target: "#proofs_item",
          content: `Every proof created on your account lives here. Those icons show what file types are included in the proof. They are also color coded. Green means “Approved”, for example.`,
          params: {
            enableScrolling: false,
            placement: "top",
          },
        },
        {
          target: "#proofs_sort",
          content:
            "You can sort proofs by status. You can also sort by workflow or current sender.",
          params: {
            placement: "right",
          },
        },
        {
          target: "#proofs_tags",
          content:
            "Tags allow you to categorize proofs however you’d like. You can assign proofs to tags anytime, and sort your proof archive by those tags here.",
          params: {
            placement: "right",
          },
        },
      ],
      tourCallbacks: {
        onStop: function () {
          window.$A.SaveCompletionOfProductTours("proof-archive");
        },
      },
    };
  },
};
</script>

<style scoped>
.classic-shell {
  padding-top: 64px;
}
.classic-body {
  padding-top: 24px;
}
.experience-switch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 16px;
  background: rgba(1, 146, 86, 0.06);
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  font-size: 13px;
  color: #4b5563;
}
.experience-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: #019256;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 999px;
  letter-spacing: 0.02em;
}
.experience-text {
  color: #4b5563;
}
.experience-link {
  color: #019256;
  font-weight: 600;
  text-decoration: none;
}
.experience-link:hover {
  text-decoration: underline;
  color: #017a48;
}
</style>
